import { Column } from "../decorators/column";
import { autoserializeAs } from "cerializr";

export class ReasonsForNotFittingHearingAidDevicesReport {
    @autoserializeAs(String)
    @Column({
        columnName: 'Reason'
    })
    reason: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Count'
    })
    count: string;
    @autoserializeAs(String)
    @Column({
        columnName: 'Percent'
    })
    percent: string;
}
